import { NavItemWrapper, NavWrapper } from '@nkr/views/center-admin/styles';
import { Button, Nav } from 'react-bootstrap';
import { DonorShieldDirectCategory, OrganType } from '@nkr/enums/index';
import { IDonorShieldDirectCounts } from '@nkr/models/index';
import { useAppHookContext } from '@nkr/utils/rest-api';

interface IProps {
    centerId: number,
    activeTab: DonorShieldDirectCategory,
    isNkrAdmin: boolean,
    counts: IDonorShieldDirectCounts,
    onTabChange: (tab: DonorShieldDirectCategory) => void
}

const Filters = (props: IProps) => {
    const { app } = useAppHookContext();

    const openLink = (link: string) => {
        window.open(link, "_blank");
    }

    const pendingTotal = props.counts != null ? props.counts.pendingTransplantTotal : 0;
    const transplantedTotal = props.counts != null ? props.counts.transplantedTotal : 0;

    return (
        <NavWrapper fontSize='12px'>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '99%', marginBottom: 20 }}>
                <Nav bsStyle='pills' className='acc-pills' onSelect={(e: any) => props.onTabChange(e)} activeKey={props.activeTab} >
                    <NavItemWrapper eventKey={DonorShieldDirectCategory.PendTrans} active={props.activeTab == DonorShieldDirectCategory.PendTrans}>
                        Pending Transplant ({pendingTotal})
                    </NavItemWrapper>

                    <li role='presentation'><span>|</span></li>

                    <NavItemWrapper eventKey={DonorShieldDirectCategory.Transplanted} active={props.activeTab == DonorShieldDirectCategory.Transplanted}>
                        Transplanted ({transplantedTotal})
                    </NavItemWrapper>

                    {!props.isNkrAdmin &&
                        <li role='presentation'><span>|</span></li>
                    }

                    {!props.isNkrAdmin &&
                        <NavItemWrapper eventKey={DonorShieldDirectCategory.AddDonor} active={props.activeTab == DonorShieldDirectCategory.AddDonor}>
                            Add Donor Shield
                        </NavItemWrapper>
                    }

                    {!props.isNkrAdmin && props.activeTab == DonorShieldDirectCategory.EditDonor &&
                        <>
                            <li role='presentation'><span>|</span></li>
                            <NavItemWrapper eventKey={DonorShieldDirectCategory.EditDonor} active={props.activeTab == DonorShieldDirectCategory.EditDonor}>
                                Edit Donor Shield
                            </NavItemWrapper>
                        </>
                    }
                </Nav>
            </div>
            <div style={{ float: 'right' }}>
                <span style={{ display: 'inline-flex', width: 'max-content' }}>
                    <label style={{ marginRight: 5, marginTop: 8 }}>
                        Donor Shield Reimbursement Policies:
                    </label>
                    {app.site.organType == OrganType.Kidney && (
                        <Button style={{ marginRight: 5 }} bsStyle='danger' onClick={() => openLink(`https://www.donorshield.com/policy`)} >
                            Kidney
                        </Button>
                    )}
                    <Button bsStyle='warning' onClick={() => openLink(`https://www.donorshield.com/liverpolicy`)}>
                        Liver
                    </Button>
                </span>
            </div>
        </NavWrapper>
    );
}

export default Filters;